import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) => ({
  topBarContainer: {
    height: 56,
    backgroundColor: 'white',
    position: 'fixed',
    zIndex: 99,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      marginTop: 64,
      height: 'auto',
    },
  },
  topBarContentExternal: {
    display: 'flex',
    padding: '16px 0',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  logoWrapper: {
    padding: '0 24px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  topBarContent: {
    display: 'flex',
    paddingTop: 16,
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      textAlign: 'center',
      padding: '16px 0',
    },
  },
  widgetContainer: {
    fontWeight: 700,
    marginLeft: 'auto',
    [theme.breakpoints.only('sm')]: {
      marginLeft: 0,
    },
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
    },
  },
  greetingsContainer: {
    fontWeight: 'bold',
    [theme.breakpoints.up('sm')]: {
      paddingLeft: 24,
    },
  },
}));
